import { useEffect, useState } from 'react';
import { Icon } from '../common/Icons';

function ArticleLikeButton({ id }) {
  const [state, setState] = useState(false);

  const updateState = () => {
    const storage = JSON.parse(localStorage.getItem('savedArticles'));
    storage.includes(id) ? setState(true) : setState(false);
  };

  useEffect(() => {
    updateState();
  }, []);

  const onClick = () => {
    const storage = JSON.parse(localStorage.getItem('savedArticles'));

    if (storage.some(item => item === id)) {
      if (storage.indexOf(id) !== -1) {
        storage.splice(storage.indexOf(id), 1);
        localStorage.setItem('savedArticles', JSON.stringify(storage));

        return updateState();
      }
    } else {
      storage.push(id);
      localStorage.setItem('savedArticles', JSON.stringify(storage));

      return updateState();
    }
  };

  return state ? (
    <button type="button" onClick={onClick}>
      <span className="sr-only">Remove this article from your saved list</span>
      <Icon.HeartBig aria-hidden />
    </button>
  ) : (
    <button type="button" onClick={onClick}>
      <span className="sr-only">Save this article</span>
      <Icon.HeartOutline aria-hidden />
    </button>
  );
}

export default ArticleLikeButton;
